import Heading from '@zenbusiness/zui/Heading';
import SharedLottieAsset from '@zenbusiness/zui/SharedLottieAsset';
import Stack from '@zenbusiness/zui/Stack';
import PropTypes from 'prop-types';

export default function CheckDepositLoading({
  url,
  text,
  height,
  loadCompletedHandler = () => {}
}) {
  return (
    <Stack
      alignItems="center"
      aria-label="animation loading"
      height="100%"
      justifyContent="center"
    >
      <Stack
        alignItems="center"
        height={height}
        justifyContent="center"
      >
        <SharedLottieAsset
          onComplete={loadCompletedHandler}
          options={{ loop: false }}
          src={url}
        />
      </Stack>
      <Heading
        size="2xl"
        weight="bold"
      >
        {text}
      </Heading>
    </Stack>
  );
}

CheckDepositLoading.propTypes = {
  url: PropTypes.string.isRequired,
  text: PropTypes.string,
  height: PropTypes.string,
  loadCompletedHandler: PropTypes.func
};
